import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const LearnPreview = () => {
    return (
        <section
            data-testid="learn-preview-section"
            className="relative z-10 py-24 lg:py-36 overflow-hidden"
            style={{ background: "linear-gradient(135deg, #5D3A5D 0%, #432843 100%)" }}
        >
            <div className="st-container">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.9 }}
                        className="lg:col-span-7 text-[var(--st-cream)]"
                    >
                        <p className="eyebrow text-[var(--st-gold)] mb-6">05 — Learn from the studio</p>
                        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
                            Fifteen years.<br />
                            Three workshops.<br />
                            <span className="italic text-[var(--st-gold)]">One open door.</span>
                        </h2>
                        <p className="mt-8 text-lg leading-relaxed max-w-xl text-[#e6dce6]">
                            Sugandhi has built the studio she wishes she could have learned from
                            when she was twenty-two. Half-day workshops, mentorship cohorts, and
                            an online course on building a brand that gets remembered.
                        </p>

                        <div className="flex flex-wrap gap-3 mt-10">
                            <Link
                                to="/learn"
                                data-testid="learn-cta-workshops"
                                className="btn-primary bg-[var(--st-gold)] border-[var(--st-gold)] text-[var(--st-ink)] hover:bg-[var(--st-cream)] hover:border-[var(--st-cream)]"
                            >
                                Workshops <ArrowUpRight size={16} />
                            </Link>
                            <Link
                                to="/learn"
                                data-testid="learn-cta-mentorship"
                                className="btn-ghost border-[var(--st-cream)] text-[var(--st-cream)] hover:bg-[var(--st-cream)] hover:text-[var(--st-purple)]"
                            >
                                Mentorship <ArrowUpRight size={16} />
                            </Link>
                            <Link
                                to="/learn"
                                data-testid="learn-cta-courses"
                                className="btn-ghost border-[var(--st-cream)] text-[var(--st-cream)] hover:bg-[var(--st-cream)] hover:text-[var(--st-purple)]"
                            >
                                Online course <ArrowUpRight size={16} />
                            </Link>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.96 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1, delay: 0.2 }}
                        className="lg:col-span-5 lg:col-start-8 relative"
                    >
                        <div className="relative aspect-[4/5] overflow-hidden">
                            <img
                                src="https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80"
                                alt="Workshop session"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60 to-transparent text-[var(--st-cream)]">
                                <p className="eyebrow text-[var(--st-gold)]">Next workshop</p>
                                <p className="font-serif text-2xl italic mt-1">Brand-thinking for founders</p>
                                <p className="text-sm mt-1 opacity-80">A half-day intensive · Gurgaon & online</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default LearnPreview;
